import React, { useRef, useEffect, useContext } from 'react'
import { AppContext, DispatchContext } from "../AppContext";


export default function SVGComponent(props) {
    return (
        <div
            className="svg-container"
            dangerouslySetInnerHTML={{ __html: props.svgString }}
            style={{ width:props.width, height:props.height }}
        />
    );
};